export abstract class PplUiTimezoneService {
  abstract getDefaultTimezone(): string;
}
